<h1 class="page-title">Credential Maintenance</h1>
<span *ngIf="ccpEligible">
  <div *ngIf="ccpStatus && ccpStatus.reinstate">
    <p>
      Because your credential is expired less than 6 months, you have the option
      of entering the number of Category 1 CEUs indicated below and paying the
      required reinstatement fee. Your continuing education hours must be earned
      within the dates of {{ ccpBegins | date : "longDate" }} -
      {{ ccpEnds | date : "longDate" }}.
    </p>
    <p>
      <strong
        >If you do not enter CEUs and pay the reinstatement fee by
        {{ ccpGraceEnds | date : "longDate" }}</strong
      >, you must successfully complete the examination to reinstate your
      expired credential. Your credential will be reinstated when you
      successfully complete the examination. If you have more than one expired
      credential, you must pass all examinations to reinstate your expired
      credentials.
    </p>
  </div>
  <div *ngIf="ccpStatus.zoneStatus === 'GREEN'" style="color: green">
    <p><strong
      >Congratulations! You are not required to document CEUs due to your
      outstanding performance on assessments.</strong> To finish the recertification process, you must click on [Recertify Now] below.  
      The [Recertify Now] button will become active when you are within 6 months of your credential expiration date.
    </p>
  </div>

  <div *ngIf="ccpStatus && !ccpStatus.reinstate && !ccpAudit">
    <h2 class="heading--3">Options for maintaining credentials are below:</h2>

    <p>
      <strong>Option 1:</strong> Completion of Category 1 Continuing Education
      (CE) hours. You may use credits from the American Association for
      Respiratory Care Continuing Respiratory Care Education Program
      (AARC-CRCE®) to fulfill the NBRC Credential Maintenance Program
      requirements as well as any CE hours accepted by your state licensure
      board (if applicable).
    </p>
    <p *ngIf="ccpStatus && !ccpStatus.reinstate && !ccpAudit">
      CE course activity may be entered at any time prior to your credential
      expiration, but you must click on the [Recertify Now] button to complete
      your recertification. Use the Add Course or Import AARC Courses options
      below to document your CEUs.
    </p>
    <p>
      <button class="button button--alt" routerLink="/assessment/">
        Go to Assessments
      </button>
    </p>
    <p>
      Please note, the number of CEUs listed below will not be final until you
      have completed your last assessment or 6 months prior to your expiration
      date.
    </p>
  </div>
  <!-- <div>
	<p>You may use credits from the American Association for Respiratory Care Continuing Respiratory Care Education Program (AARC-CRCE®) to 
			fulfill the NBRC Credential Maintenance Program requirements as well as any CE hours accepted by your state licensure board (if applicable). 
			<span *ngIf="!ccpAudit">Add/Import courses below.</span></p>
</div> -->
  <div class="stat-pods">
    <div class="stat-pod">
      <span class="stat-pod__number" *ngIf="hoursAchieved?.greHoursRequired > 0"
        >{{ hoursAchieved?.greHours }} of
        {{ hoursAchieved?.greHoursRequired }}</span
      >
      <span
        class="stat-pod__number stat-pod__number--not-applicable"
        *ngIf="
          !hoursAchieved?.greHoursRequired ||
          hoursAchieved?.greHoursRequired === 0
        "
        >N/A</span
      >
      <span class="stat-pod__label">General Hours</span>
    </div>
    <div class="stat-pod">
      <span class="stat-pod__number" *ngIf="hoursAchieved?.neoHoursRequired > 0"
        >{{ hoursAchieved?.neoHours }} of
        {{ hoursAchieved?.neoHoursRequired }}</span
      >
      <span
        class="stat-pod__number stat-pod__number--not-applicable"
        *ngIf="
          !hoursAchieved?.neoHoursRequired ||
          hoursAchieved?.neoHoursRequired === 0
        "
        >N/A</span
      >
      <span class="stat-pod__label">Neonatal&#x2F;Pediatric</span>
    </div>
    <div class="stat-pod">
      <span class="stat-pod__number" *ngIf="hoursAchieved?.pftHoursRequired > 0"
        >{{ hoursAchieved?.pftHours }} of
        {{ hoursAchieved?.pftHoursRequired }}</span
      >
      <span
        class="stat-pod__number stat-pod__number--not-applicable"
        *ngIf="
          !hoursAchieved?.pftHoursRequired ||
          hoursAchieved?.pftHoursRequired === 0
        "
        >N/A</span
      >
      <span class="stat-pod__label">Pulmonary Function</span>
    </div>
    <div class="stat-pod">
      <span class="stat-pod__number" *ngIf="hoursAchieved?.sdsHoursRequired > 0"
        >{{ hoursAchieved?.sdsHours }} of
        {{ hoursAchieved?.sdsHoursRequired }}</span
      >
      <span
        class="stat-pod__number stat-pod__number--not-applicable"
        *ngIf="
          !hoursAchieved?.sdsHoursRequired ||
          hoursAchieved?.sdsHoursRequired === 0
        "
        >N/A</span
      >
      <span class="stat-pod__label">Sleep Disorder</span>
    </div>
    <div class="stat-pod">
      <span
        class="stat-pod__number"
        *ngIf="hoursAchieved?.accsHoursRequired > 0"
        >{{ hoursAchieved?.accsHours }} of
        {{ hoursAchieved?.accsHoursRequired }}</span
      >
      <span
        class="stat-pod__number stat-pod__number--not-applicable"
        *ngIf="
          !hoursAchieved?.accsHoursRequired ||
          hoursAchieved?.accsHoursRequired === 0
        "
        >N/A</span
      >
      <span class="stat-pod__label">Adult Critical Care</span>
    </div>
    <div class="stat-pod">
      <span class="stat-pod__number" *ngIf="hoursAchieved?.aecHoursRequired > 0"
        >{{ hoursAchieved?.aecHours }} of
        {{ hoursAchieved?.aecHoursRequired }}</span
      >
      <span
        class="stat-pod__number stat-pod__number--not-applicable"
        *ngIf="
          !hoursAchieved?.aecHoursRequired ||
          hoursAchieved?.aecHoursRequired === 0
        "
        >N/A</span
      >
      <span class="stat-pod__label">Asthma Educator</span>
    </div>
  </div>
  <div *ngIf="!ccpAudit" class="button-list">
    <button
      class="button button--alt"
      [disabled]="recertEligible === false"
      (click)="performRecertificationTask()"
    >
      Recertify Now
    </button>
    <button
      class="button button--alt"
      routerLink="/practitioner/credentials-maintenance/courses/add"
    >
      Add Course
    </button>
    <button
      class="button button--alt"
      title="Import CRCE records from AARC"
      (click)="openImportCourseForm()"
    >
      Import AARC Courses
    </button>
    <button class="button button--alt" (click)="generateCEReport()">
      List of Courses
    </button>
  </div>
  <!-- <p style="color:red">Due to a system upgrade, Import AARC Courses is currently unavailable. We anticipate this service will be available Friday, June 24th. Please check back for updates.</p> -->

  <app-import-course
    *ngIf="importCourseFormVisible"
    (onImportCourse)="getCredentialsData()"
    (onCancelForm)="closeForm()"
  ></app-import-course>


  <p *ngIf="ccpStatus && ccpStatus.reinstate">
    You must click on the [Recertify Now] button to complete your
    recertification. The [Recertify Now] button will become active after you
    have entered the CE hours needed to recertify your credential(s).
  </p>
  <p *ngIf="ccpStatus && !ccpAudit && !ccpStatus.reinstate">
    The [Recertify Now] button will become active after you have entered the
    required number of CE hours and you are
    <u>within 6 months of your credential expiration date</u>.
  </p>
  <p *ngIf="ccpStatus && !ccpAudit && !ccpStatus.reinstate">
    Your continuing education hours must be within the dates of
    {{ ccpBegins | date : "longDate" }} - {{ ccpEnds | date : "longDate" }}.
  </p>
  <section *ngIf="ccpAudit" style="background-color: yellow">
    <p>
      You have been selected to provide documentation of the CE information you
      entered as part of our random audit process. To complete your
      recertification, you must submit the information below by
      {{ ccpStatus.AuditDue | date : "M/d/yyyy" }}:
    </p>
    <ul>
      <li>
        A copy of the certificate for each CE course you entered. All
        certificates must include your name, date of completion and the number
        of hours awarded.
      </li>
      <li>A copy of this notice or the email sent to you.</li>
    </ul>
    <p>
      To expedite this process, submit copies of the CE completion certificates
      along with this notice by fax to 913.712.9283 or by email in a single PDF
      file to <a href="Service@nbrc.org">Service@nbrc.org</a>. We are not able
      to accept screenshots and/or photos of CE completion certificates. To
      review the courses you submitted, log in to the Practitioner Portal at
      <a href="http://NBRC.org">nbrc.org</a>
      and select 'Enter my CEUs.' If you are unable to submit your documentation
      by fax or email, mail your documents to:
    </p>
    <p>NBRC<br />10801 Mastin Street, Suite 300<br />Overland Park, KS 66210</p>
    <p>
      If you have questions regarding this notice, please contact us at
      913.895.4900 or <a href="Service@nbrc.org">Service@nbrc.org</a>.
    </p>
  </section>

  <app-courses
    *ngIf="ccpStatus.zoneStatus !== 'GREEN'"
    [courses]="courses"
    [ccpAudit]="ccpAudit"
    (onCourseDeleted)="deleteCourse($event)"
  ></app-courses>
</span>
<h4
  *ngIf="
    ccpEligible === false &&
    ccpStatus &&
    ccpStatus.feeOverrideAmount &&
    ccpStatus.feeOverrideAmount > 0
  "
>
  <p>
    You can reinstate your credential via an exception that you were granted by
    the NBRC. Click recertify now to enter payment information.
  </p>
  <button
    class="button button--alt--color"
    (click)="recertify = true; performRecertificationTask()"
  >
    Recertify Now
  </button>
</h4>
<h4 *ngIf="ccpEligible === false && ccpStatus && !ccpStatus.feeOverrideAmount">
  You are not required to participate in the Credential Maintenance Program.
</h4>
<p></p>
<ul *ngIf="ccpEligible !== false" class="list list--bare">
  <li class="button-text-combo">
    <a
      href="#"
      routerLink="/"
      class="button button--tertiary button-text-combo__button"
      >Go</a
    >
    <span class="button-text-combo__text"
      ><strong>Option 2: </strong>Pass an NBRC credentialing examination not
      previously completed.</span
    >
  </li>
  <li class="button-text-combo">
    <a href="#" class="button button--tertiary button-text-combo__button">Go</a>
    <span class="button-text-combo__text">
      <strong>Option 3: </strong>Retake and pass the respective examination for
      the highest credential held that is subject to the CMP.
    </span>
  </li>
</ul>
